import { apiInstance } from "api";

export const getQuestionnaireData = async () => {
	return (await apiInstance.get<ApiResponse<QuestionnaireResponse>>(`/visa_orders/generate-guest-questionnaire`)).data
		.data;
};

export const getAnswerData = async (application_id: string) =>
	(await apiInstance.get<ApiResponse<TAnswer[]>>(`/visa_answers/started/${application_id}`)).data.data;

export const postAnswer = (
	order_id: string,
	application_id: string,
	data: PostAnswerData,
	onProgress?: ((event: UploadProgressEvent) => void) | undefined
) => {
	const form = new FormData();
	form.append("visa_questions_id", data.visa_questions_id);
	form.append("traveller_id", data.traveller_id);
	form.append("answer", data.answer);
	if (data.file) {
		form.append("fileData", data.file);
	}

	return apiInstance.post<ApiResponse<TAnswer>>(
		`/visa_answers/order/${order_id}/application/${application_id}`,
		form,
		{
			onUploadProgress: (event) => {
				onProgress?.({ percent: (event.loaded / (event.total ?? 100)) * 100 });
			}
		}
	);
};
